import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { BaseFormComponent } from '../../../../core/layout/components/abstracts/base-form.component';
import { FormFields } from '../../../../core/types';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormControlComponent } from '../../../../shared/components/form-control/form-control.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { MaxWidthDirective } from '../../../../shared/directives/max-width.directive';
import { ICustomer } from '../../core/interfaces/ICustomer';
import { CustomersService } from '../../core/services/CustomersService';
import { finalize } from 'rxjs';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { DictionariesStore } from '../../../../core/stores/DictionariesStore';
import { Dictionaries } from '../../../../core/enums/Dictionaries';
import { SelectComponent } from '../../../../shared/components/select/select.component';

@Component({
  selector: 'app-add-edit-customer-form',
  standalone: true,
  imports: [
    FormControlComponent,
    ReactiveFormsModule,
    TranslatePipe,
    MaxWidthDirective,
    SelectComponent,
  ],
  templateUrl: './add-edit-customer-form.component.html',
  styleUrl: './add-edit-customer-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddEditCustomerFormComponent extends BaseFormComponent<ICustomer> {

  @Input({ required: true }) isAdd: boolean;

  public readonly countries = inject(DictionariesStore)[Dictionaries.COUNTRIES];

  protected override readonly formFields: FormFields = {
    id: new FormControl(null),
    email: new FormControl(null, Validators.compose([Validators.email])),
    companyName: new FormControl(null),
    firstName: new FormControl(null),
    lastName: new FormControl(null),
    countryId: new FormControl(null),
    street: new FormControl(null),
    city: new FormControl(null),
    postalCode: new FormControl(null),
  };

  private readonly _customersService = inject(CustomersService);

  protected override formValidActions(): void {
    const customer: ICustomer = this.form.value;

    if (this.isAdd) {
      this._customersService.createCustomer(customer)
        .pipe(
          finalize(() => this.unlockForm())
        )
        .subscribe({
          next: res => this.formFinished.emit(res.data),
          error: ({ error }: ApiErrorResponse) => {
            this.notificationService.pushError(
              'Fehler'.trans('notifications/error.Title'),
              error.message.trans(`create-customer/notifications/${error.message}.Message`)
            );
          }
        });
    } else {
      this._customersService.updateCustomer(customer)
        .pipe(
          finalize(() => this.unlockForm())
        )
        .subscribe({
          next: () => {
            this.formFinished.emit(
              {
                ...customer,
                countryName: customer.countryId
                  ? this.countries().find(c => c.id === customer.countryId)?.name
                  : null,
              }
            );
          },
          error: ({ error }: ApiErrorResponse) => {
            this.notificationService.pushError(
              'Fehler'.trans('notifications/error.Title'),
              error.message.trans(`update-customer/notifications/${error.message}.Message`)
            );
          }
        });
    }
  }
}
